/**
 * PermissionNotice Component
 *
 * Friendly inline notice shown when a user lacks permission to access a page or widget.
 * Uses an informational (not error) tone since this is a role boundary, not a failure.
 *
 * @module components/common/PermissionNotice
 */

interface PermissionNoticeProps {
  title?: string;
  description: string;
}

function LockIcon(): React.ReactElement {
  return (
    <svg
      className="h-10 w-10"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
      <path d="M7 11V7a5 5 0 0110 0v4" />
    </svg>
  );
}

export function PermissionNotice({
  title = 'Access restricted',
  description,
}: PermissionNoticeProps): React.ReactElement {
  return (
    <div className="mx-auto max-w-md rounded-xl bg-blue-50 p-12 text-center shadow-sm dark:bg-blue-950/30">
      <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-2xl bg-blue-100 text-blue-500 dark:bg-blue-900/40 dark:text-blue-400">
        <LockIcon />
      </div>
      <h3 className="mt-4 text-lg font-semibold text-ink-dark">{title}</h3>
      <p className="mt-2 text-sm text-ink-medium">{description}</p>
    </div>
  );
}
